<template>
  <v-card>
    <form data-vv-scope="filterForm">
      <v-expansion-panel expand :value="[true]">
        <v-expansion-panel-content>
          <div slot="header">
            <v-icon>mdi-filter-variant</v-icon> Filters
          </div>
          <v-card>
            <v-card-text>
              <v-container fluid grid-list-lg>
                <v-layout row wrap>
                  <v-flex xl3 lg4 xs6>
                    <v-autocomplete data-vv-scope="filterForm" :items="tariffList" v-model="filters.tarf" :label="filtersLabel.tarf" item-text="label" item-value="value" clearable></v-autocomplete>
                  </v-flex>
                  <v-flex xl3 lg4 xs6>
                    <v-autocomplete data-vv-scope="filterForm" :items="coverList" v-model="filters.cover" :label="filtersLabel.cover" item-text="label" item-value="value" clearable></v-autocomplete>
                  </v-flex>
                  <v-flex xl3 lg4 xs6>
                    <cal-picker data-vv-scope = "filterForm" :label="filtersLabel.effDate" v-model="filters.effDate"></cal-picker>
                  </v-flex>
                  <v-flex xl3 lg4 xs6>
                    <v-text-field data-vv-scope="filterForm" v-model="filters.ncbPct" :label="filtersLabel.ncbPct" :error-messages="errors.collect('ncbPct')" data-vv-name="ncbPct"></v-text-field>
                  </v-flex>
                </v-layout>
                <transition name="slide-x-transition" mode="out-in">
                  <v-layout row wrap v-if="showDetailFilters">
                    <v-flex xl3 lg4 xs6>
                      <v-text-field data-vv-scope="filterForm" v-model="filters.ncbYr" :label="filtersLabel.ncbYr" :error-messages="errors.collect('ncbYr')" data-vv-name="ncbYr"></v-text-field>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-autocomplete data-vv-scope="filterForm" :items="permitStatusList()" v-model="filters.permitStatus" :label="filtersLabel.permitStatus" item-text="label" item-value="value"  clearable></v-autocomplete>
                    </v-flex>
                  </v-layout>
                </transition>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-btn flat="flat" @click.native="showDetailFilters = true" v-if="!showDetailFilters">Show More Filters</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" flat="flat" @click.native="doClearFilters">Clear Filters</v-btn>
              <v-btn color="primary" flat="flat" type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
            </v-card-actions>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </form>
    <v-flex xs12>
      <v-layout row>
        <v-flex xs12 class="mt-3">
          <message :messages="messages"></message>
        </v-flex>
        <v-spacer></v-spacer>
        <v-menu offset-x :nudge-left="370" :close-on-content-click="false" :min-width="300" :max-height="400">
          <v-btn color="secondary" class="white--text" slot="activator">
            <span>Columns</span>
            <v-icon right dark>mdi-table-column-plus-after</v-icon>
          </v-btn>
          <v-card>
            <v-card-text>
              <template v-if="columns.length > 0">
                <v-checkbox v-for="column in columns" :key="column.value" :label="column.text" :value="column.value" v-model="selectedColumns"></v-checkbox>
              </template>
              <template v-else>
                No column found
              </template>
            </v-card-text>
          </v-card>
        </v-menu>
      </v-layout>
    </v-flex>
    <v-data-table v-bind:headers="listHeaders" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="index" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
      <template slot="items" slot-scope="props">
        <td v-for="column in selectedColumns" :key="column">
          {{props.item[column]}}
        </td>
        <td class="text-xs-right">
          <table-action :rowData="props" review @review="doReview" remove @remove="doPromptRemove(props.item)"></table-action>
        </td>
      </template>
    </v-data-table>
    <v-btn color="primary" dark class="mb-2" @click="doNewNCDForm">New NCD<v-icon>mdi-plus</v-icon></v-btn>
    <v-dialog v-model="reviewNCDMode" max-width="900px" persistent>
      <v-card>
        <v-card-title v-if="newNCD">
          <span class="headline">New No Claim Discount (NCD)</span>
        </v-card-title>
        <v-card-title v-else>
          <span class="headline">No Claim Discount (NCD)</span>
        </v-card-title>
        <form data-vv-scope = "NCDForm">
          <v-card-text>
            <message :messages="messages"></message>
            <v-container fluid grid-list-lg>
              <v-layout row wrap  v-if="newNCD">
                <v-flex xs6>
                  <v-autocomplete data-vv-scope = "NCDForm" :items="tariffList" v-model="NCDForm.tarf" :label="labels.tarf" item-text="label" item-value="value" data-vv-name="tarf" :data-vv-as="labels.tariff" :error-messages="errors.collect('NCDForm.tarf')" v-validate="'required'"></v-autocomplete>
                </v-flex>
                <v-flex xs6>
                  <v-autocomplete data-vv-scope = "NCDForm" :items="coverList" v-model="NCDForm.cover" :label="labels.cover" item-text="label" item-value="value" data-vv-name="cover" :data-vv-as="labels.cover" :error-messages="errors.collect('NCDForm.cover')" v-validate="'required'"></v-autocomplete>
                </v-flex>
                <v-flex xs6>
                  <cal-picker data-vv-scope = "NCDForm" :label="labels.effDate" v-model="NCDForm.effDate" :error-messages="errors.collect('NCDForm.effDate')" data-vv-name="effDate" :data-vv-as="labels.effDate" v-validate="'required'"></cal-picker>
                </v-flex>
                <v-flex xs6>
                  <v-text-field data-vv-scope = "NCDForm" v-model="NCDForm.ncbYr" :label="labels.ncbYr" :error-messages="errors.collect('NCDForm.ncbYr')" data-vv-name="ncbYr" :data-vv-as="labels.ncbYr" v-validate="'numeric|max:10|required'"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field data-vv-scope = "NCDForm" v-model="NCDForm.ncbPct" :label="labels.ncbPct" :error-messages="errors.collect('NCDForm.ncbPct')" data-vv-name="ncbPct" :data-vv-as="labels.ncbPct" v-validate="'decimal:2|max:18|required'"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-autocomplete data-vv-scope = "NCDForm" :items="permitStatusList()" v-model="NCDForm.permitStatus" :label="labels.permitStatus" item-text="label" item-value="value" data-vv-name="permitStatus" :data-vv-as="labels.permitStatus" :error-messages="errors.collect('NCDForm.permitStatus')" v-validate="'required'"></v-autocomplete>
                </v-flex>
              </v-layout>
              <v-layout row wrap  v-else>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{labels.tarf}}</v-subheader>
                  <div class="title">{{NCDForm.tarfDesc}}</div>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{labels.cover}}</v-subheader>
                  <div class="title">{{NCDForm.coverDesc}}</div>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{labels.effDate}}</v-subheader>
                  <div class="title">{{formatDate(NCDForm.effDate)}}</div>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{labels.ncbYr}}</v-subheader>
                  <div class="title">{{NCDForm.ncbYr}}</div>
                </v-flex>
                <v-flex xs6>
                  <v-text-field data-vv-scope = "NCDForm" v-model="NCDForm.ncbPct" :label="labels.ncbPct" :error-messages="errors.collect('NCDForm.ncbPct')" data-vv-name="ncbPct" :data-vv-as="labels.ncbPct" v-validate="'decimal:2|max:10|required'"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-autocomplete data-vv-scope = "NCDForm" :items="permitStatusList()" v-model="NCDForm.permitStatus" :label="labels.permitStatus" item-text="label" item-value="value" data-vv-name="permitStatus" :data-vv-as="labels.permitStatus" :error-messages="errors.collect('NCDForm.permitStatus')" v-validate="'required'"></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click.native="doCloseNCDForm">Cancel</v-btn>
            <v-btn color="primary" flat type="submit" :loading="submitting" @click.prevent="doSaveNCDForm">
              {{newNCD ? 'Save NCD' : 'Update NCD'}}
              <v-icon right>{{newNCD ? 'mdi-plus' : 'mdi-content-save'}}</v-icon>
            </v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>
    <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected No Claim Disount?
      <div class="title">{{deleteNCD}}</div>
    </confirm>
  </v-card>
</template>

<script>
import clone from 'clone'
import { listMixin } from '@/components/parameters/reusable/listMixins'
import { filterQuery, expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import FieldMixin from '@/mixins/field'
import { mtrPermitStatus } from '@/const/underwriting/motor'
import { removeTime, formatDisplayDateTime2 } from '@/utils/date'
import { extractMenu } from '@/utils/extract'
export default {
  data() {
    return {
      columns: [
        { text: 'Tariff', value: 'tarfDesc' },
        { text: 'Coverage', value: 'coverDesc' },
        { text: 'No Claim Bonus Year', value: 'ncbYr' },
        { text: 'Effective Date', value: 'effDate' },
        { text: 'Percentage of No Claim Bonus', value: 'ncbPct' },
        { text: 'Permission Status', value: 'permitStatusDesc' }
      ],
      selectedColumns: ['tarfDesc', 'coverDesc', 'effDate', 'ncbPct'],
      pagination: {
        sortBy: 'effDate'
      },
      filtersLabel: {
        tarf: 'Tariff',
        cover: 'Coverage',
        ncbYr: 'No Claim Bonus Year',
        effDate: 'Effective Date',
        ncbPct: 'Percentage of No Claim Bonus',
        permitStatus: 'Permission Status'
      },
      filters: {
        tarf: null,
        cover: null,
        ncbYr: null,
        effDate: null,
        ncbPct: null,
        permitStatus: null
      },
      labels: {
        tarf: 'Tariff',
        cover: 'Coverage',
        ncbYr: 'No Claim Bonus Year',
        effDate: 'Effective Date',
        ncbPct: 'Percentage of No Claim Bonus',
        permitStatus: 'Permission Status'
      },
      NCDForm: {
        tarf: null,
        tarfDesc: null,
        cover: null,
        coverDesc: null,
        ncbYr: null,
        effDate: null,
        ncbPct: null,
        permitStatus: null
      },
      loading: null,
      submitting: false,
      totalItems: 0,
      reviewNCDMode: false,
      newNCD: false,
      tempTariffList: [],
      tempCoverList: [],
      showDetailFilters: false,
      deleteNCD: '',
      promptRemove: false,
      menu: []
    }
  },
  computed: {
    busClsMenu() {
      return this.$store.state.parameters.busCls.busClsMenu.menu
    },
    coverList() {
      return this.$store.state.parameters.busCls.busClsMenu.busClsCoverList
    },
    tariffList() {
      return this.$store.state.parameters.busCls.busClsMenu.busClsTarfList
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination.descending': function (value) {
      this.fetchData(false)
    },
    'pagination.page': function (value) {
      this.fetchData(false)
    },
    'pagination.rowsPerPage': function (value) {
      this.fetchData(false)
    },
    'pagination.sortBy': function (value) {
      this.fetchData(false)
    }
  },
  methods: {
    async fetchData(options) {
      this.tempTariffList = []
      this.tempCoverList = []
      this.loading = true
      const apiURI = this.busClsMenu.mtrNCDList
      const { page, rowsPerPage } = this.pagination
      if (apiURI) {
        try {
          const expand = {
            busCls: this.id,
            page: page - 1,
            size: rowsPerPage
          }
          let massageFilters = clone(this.filters)
          if (massageFilters.effDate) {
            massageFilters.effDate = formatDisplayDateTime2(removeTime(massageFilters.effDate))
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), massageFilters, this.pagination.sortBy, this.pagination.descending))
          const { data } = result.data

          if (data) {
            this.tempCoverList = result.data.mtrNCDCoverType
            this.tempTariffList = result.data.mtrNCDTarfType
            this.items = []
            data.map((NCD) => {
              const tarfDesc = this.tempTariffList.find(item => item.value === NCD.tarf)
              const coverDesc = this.tempCoverList.find(item => item.value === NCD.cvrType)
              const convertList = {
                tarfDesc: tarfDesc.label,
                tarf: NCD.tarf,
                coverDesc: coverDesc.label,
                cover: NCD.cvrType,
                ncbYr: NCD.ncbYr,
                effDate: this.formatDate(NCD.effDate),
                ncbPct: NCD.ncbPct.toFixed(2),
                permitStatus: NCD.permitStatus,
                permitStatusDesc: NCD.permitStatus + ' - ' + mtrPermitStatus[NCD.permitStatus]
              }
              this.items.push(convertList)
            })
            this.loading = false
          } else {
            this.loading = false
            this.items = []
          }
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API Url')
      }
    },
    doClearFilters() {
      this.filters.tarf = null
      this.filters.cover = null
      this.filters.ncbYr = null
      this.filters.effDate = null
      this.filters.ncbPct = null
      this.filters.permitStatus = null
      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll('filterForm').then(result => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData(false)
        }
      })
    },
    permitStatusList() {
      const list = Object.freeze(mtrPermitStatus)
      let convertArray = Object.keys(list).map(key => {
        return {
          label: key + ' - ' + list[key],
          value: key
        }
      })
      return convertArray
    },
    async doReview(item) {
      // Init Form
      const apiURI = this.busClsMenu.mtrNCDGet
      if (apiURI) {
        try {
          const expand = {
            busCls: this.id,
            tarf: item.item.tarf,
            cover: item.item.cover,
            ncbYr: item.item.ncbYr,
            effDate: item.item.effDate
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.NCDForm.tarf = data.mtrNCD.tarf
            this.NCDForm.tarfDesc = item.item.tarfDesc
            this.NCDForm.cover = data.mtrNCD.cvrType
            this.NCDForm.coverDesc = item.item.coverDesc
            this.NCDForm.ncbYr = data.mtrNCD.ncbYr
            this.NCDForm.effDate = data.mtrNCD.effDate
            this.NCDForm.ncbPct = data.mtrNCD.ncbPct
            this.NCDForm.permitStatus = data.mtrNCD.permitStatus
            this.menu = extractMenu(result.data._links)
            this.reviewNCDMode = true
            this.newNCD = false
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.errorMessage('Invalid API Url')
      }
    },
    doClearNCDForm() {
      this.NCDForm.tarf = null
      this.NCDForm.cover = null
      this.NCDForm.ncbYr = null
      this.NCDForm.effDate = null
      this.NCDForm.ncbPct = null
      this.NCDForm.permitStatus = null
    },
    doNewNCDForm() {
      this.doClearNCDForm()
      this.newNCD = true
      this.reviewNCDMode = true
    },
    doCloseNCDForm() {
      this.resetValidator()
      this.resetMessages()
      this.doClearNCDForm()
      this.newNCD = false
      this.reviewNCDMode = false
    },
    doSaveNCDForm() {
      this.resetMessages()
      this.$validator.validateAll('NCDForm').then(result => {
        if (result) {
          if (this.newNCD) {
            this.doCreateNCD()
          } else {
            this.doUpdateNCD()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreateNCD() {
      const apiURI = this.busClsMenu.mtrNCDCreate
      if (apiURI) {
        try {
          const formatForm = {
            busCls: this.id,
            tarf: this.NCDForm.tarf,
            cvrType: this.NCDForm.cover,
            ncbYr: this.NCDForm.ncbYr,
            effDate: this.NCDForm.effDate,
            ncbPct: this.NCDForm.ncbPct,
            permitStatus: this.NCDForm.permitStatus
          }
          const result = await this.$http.post(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doCloseNCDForm()
            this.fetchData(true)
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdateNCD() {
      try {
        const apiURI = this.menu.mtrNCDUpdate
        if (apiURI) {
          const formatForm = {
            busCls: this.id,
            tarf: this.NCDForm.tarf,
            cvrType: this.NCDForm.cover,
            ncbYr: this.NCDForm.ncbYr,
            effDate: this.NCDForm.effDate,
            ncbPct: this.NCDForm.ncbPct,
            permitStatus: this.NCDForm.permitStatus
          }
          const result = await this.$http.put(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doCloseNCDForm()
            this.fetchData(true)
          }
        }
      } catch (error) {
        const { data } = error
        if (data) {
          this.message(data)
          this.fieldMessage(data)
        }
      }
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedNCD = data
        this.deleteNCD = data.tarfDesc + ' - ' + data.coverDesc
      }
    },
    async doRemove() {
      const apiURI = this.$store.state.parameters.busCls.busClsMenu.menu.mtrNCDDelete
      if (apiURI) {
        this.loading = true
        var dateString = this.selectedNCD.effDate
        var dateParts = dateString.split('/')
        var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0])
        const formatForm = {
          busCls: this.id,
          tarf: this.selectedNCD.tarf,
          cvrType: this.selectedNCD.cover,
          ncbYr: this.selectedNCD.ncbYr,
          effDate: dateObject,
          ncbPct: this.selectedNCD.ncbPct,
          permitStatus: this.selectedNCD.permitStatus
        }
        try {
          const result = await this.$http.post(apiURI, formatForm)
          this.notify(result.data)
          // Reinit
          this.fetchData(true)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Delete No Claim Discount')
      }
    }
  },
  created() {
    this.fetchData(true)
  },
  props: {
    id: String,
    tariff: Array,
    covers: Array
  },
  mixins: [
    listMixin,
    MessageMixin,
    FieldMixin
  ]
}
</script>

<style>

</style>
